import { render, staticRenderFns } from "./Creditcards.vue?vue&type=template&id=672e9155&scoped=true"
import script from "./Creditcards.vue?vue&type=script&lang=ts"
export * from "./Creditcards.vue?vue&type=script&lang=ts"
import style0 from "./Creditcards.vue?vue&type=style&index=0&id=672e9155&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672e9155",
  null
  
)

export default component.exports